import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
};

export const name = "toast";
const slice = createSlice({
  name,
  initialState: { ...initialState },
  reducers: {
    add: (state, { payload }) => {
      state.list.push({ ...payload, id: +new Date() });
    },
    pop: (state, { payload }) => {
      state.list = state.list.filter(item => item.id !== payload);
    },
  },
});

export const reducer = slice.reducer;
export const action = slice.actions;
